import { Media } from '../page-components/media.model';

export class Logo {
  SvgLogo?: string | null;
  SvgLogoSmall?: string | null;
  Image?: Media | null;
  ImageSmall?: Media | null;
  Favicon: Favicon[] = [];
}

export class Favicon {
  Type: string = '';
  Image: Media = new Media();
}
